import { render, staticRenderFns } from "./generateQRCode.vue?vue&type=template&id=1a20bbd2&scoped=true&"
import script from "./generateQRCode.vue?vue&type=script&lang=js&"
export * from "./generateQRCode.vue?vue&type=script&lang=js&"
import style0 from "./generateQRCode.vue?vue&type=style&index=0&id=1a20bbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a20bbd2",
  null
  
)

export default component.exports